import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import mutations from '../../../graphql/mutations';

import style from './index.module.scss';

const {
  commentMutations: { ADD_COMMENT },
} = mutations;

class AddComment extends Component {
  state = {
    comment: '',
    isButtonDisplayed: false,
  };

  onMouseEnter = () => {
    this.setState({
      isButtonDisplayed: true,
    });
  };

  onMouseLeave = () => {
    this.setState({
      isButtonDisplayed: false,
    });
  };

  onChange = e => {
    this.setState({
      comment: e.target.value,
    });
  };

  onLeaveComment = async (e, addComment) => {
    e.preventDefault();

    const { comment } = this.state;
    const { questionId, answerId, currentUser } = this.props;

    // Leave a comment either on parent question or on related answer
    if (comment && currentUser) {
      const resp = await addComment({
        variables: {
          input: {
            commentBody: comment.trim(),
            commentedItem: questionId ? 'question' : 'answer',
            userId: currentUser.id,
            questionId: questionId ? questionId : null,
            answerId: answerId ? answerId : null,
          },
        },
      })

      if (resp) {
        this.setState({
          comment: '',
        });
      }
    }
  };

  render() {
    const { isButtonDisplayed } = this.state;
    const { currentUser } = this.props;

    return (
      <div className={`row ${style['row--form']}`}>
        <img
          src={currentUser.imgUrl || 'https://i.imgur.com/qHpJwKV.jpg'}
          alt={currentUser.fullname}
          className={style.img}
        />
        <Mutation mutation={ADD_COMMENT}>
          {addComment => (
            <form
              className={`col ${style.form}`}
              onSubmit={e =>
                this.onLeaveComment(e, addComment)
              }
              onMouseEnter={this.onMouseEnter}
              onMouseLeave={this.onMouseLeave}
            >
              <textarea
                className={`form-control ${style['form-input']}`}
                name='comment'
                value={this.state.comment}
                rows={1}
                placeholder='Enter comment'
                onChange={this.onChange}
              />
              {isButtonDisplayed && (
                <button className={`btn btn-primary ${style.button}`}>
                  Add Comment
                </button>
              )}
            </form>
          )}
        </Mutation>
        {!isButtonDisplayed && (
          <p className={style['comments-options']}>
            <span className={style.option}>Recommended</span>{' '}
            <span className={style.option}>All</span>
          </p>
        )}
      </div>
    );
  }
}

AddComment.propTypes = {
  questionId: PropTypes.string,
  answerId: PropTypes.string,
  currentUser: PropTypes.object.isRequired,
}

export default withRouter(AddComment);
